import { Precedent } from 'types/precedent';
import useReferenceData from 'hooks/use-reference-data';

export default function usePrecedents(): Map<string, Precedent> {
  const referenceData = useReferenceData();
  return referenceData?.precedents ?? new Map();
}
